// dependancies
import React from "reactn";
import appHook from "../../../hooks/appHook";
import Validate from "./SubscriptionsRules";

// components
import Button from "../../_common/Button/Button";
import ProductList from "./product_list/ProductList";
import SubscriptionsProgress from "./progress/subscriptionsProgress";

// styled components
import PageTitle from "../../_common/pageTitle/PageTitle.styled";
import SideContainer from "../../_common/containers/SideContainer";
import InfoBox from "./info_box/InfoBox";

//config 
import { SubscriptionProducts } from "./product_list/Products.config";
import { InfoBoxData } from "./info_box/InfoBox.config";

const UserDetails = props => {
    const { history } = props;
    const submitForm = () => {
        history.push("/review");
    };
    const {
        values,
        handleSubmit
    } = appHook(Validate, submitForm);

    return (
        <div className="grid-container">
            <SubscriptionsProgress></SubscriptionsProgress>
            <div className="flex--space-between">
                <SideContainer>
                    <PageTitle className="color--grey-d hide-mobile">
                        Build your subscription </PageTitle>
                    <p>To receive all commemorative stamps and commemorative first day covers for one year will cost approximately €95 (€1.80 per week).</p>
                    <p>Subscribe to as many products as you like, cost will vary from issue to issue.</p>

                    <ProductList values={values} config={SubscriptionProducts}></ProductList>
                    {/* Desktop submit */}
                    <Button
                        className="bn bn--primary gtm-linkclick"
                        onClick={() => {
                            handleSubmit();
                        }}
                        type="button"
                        text="Continue"
                    />
                </SideContainer>
                <SideContainer>
                    <InfoBox config={InfoBoxData} title="Collectable Stamps Explained"></InfoBox>
                </SideContainer>
            </div>
        </div >
    );
};

export default UserDetails;
